import { FieldProps, ErrorMessage } from 'formik';
import Select, { Props, StylesConfig } from 'react-select';
import { DefaultTheme, useTheme } from 'styled-components';
import { Error } from '../Input/styles';

interface ReactSelecProps {
  error: string;
}

type MyOptionType = {
  label: string;
  value: string;
};

type IsMulti = false;

export function ReactSelect({
  options,
  field,
  form,
  placeholder,
  isMulti,
  ...rest
}: Props & FieldProps & ReactSelecProps) {
  const theme: DefaultTheme = useTheme();

  const selectStyle: StylesConfig<MyOptionType, IsMulti> = {
    control: provided => ({
      ...provided,
      border: `2px solid ${theme.colors.tertiary}`,
      color: '#fff',
      background: theme.colors.tertiary,
      height: '3rem',
      borderRadius: '0.5rem',
      boxShadow: '0 !important',

      '&:hover': {
        borderColor: theme.colors.secondary,
      },
    }),
    singleValue: provided => ({
      ...provided,
      color: theme.colors.textPrimary,
    }),
  };

  return (
    <div style={{ marginTop: '1rem' }}>
      <Select
        options={options}
        name={field.name}
        styles={selectStyle}
        isMulti={isMulti}
        {...rest}
        placeholder={placeholder}
        className="react-select-container"
        classNamePrefix="react-select"
        onChange={option => form.setFieldValue(field.name, option)}
        onBlur={field.onBlur}
        value={
          isMulti
            ? field.value
            : ((options
                ? options.find(option => option.value === field.value)
                : '') as any)
        }
      />

      <ErrorMessage name={field.name}>
        {msg => <Error>{msg}</Error>}
      </ErrorMessage>
    </div>
  );
}
